import {
    ICompanyFormDataType, ILoginFormDataType, IPropertyFormDataType, ISignupFormDataType
} from './FormDataTypes';

export const defaultSignupForm: ISignupFormDataType = {
  firstName: "",
  lastName: "",
  email: "",
  confirmEmail: "",
};

export const defaultLoginForm: ILoginFormDataType = {
  username: "",
  password: "",
};

export const defaultFileUploadForm: FileUploadDataType = {
  name: "",
  file: [],
};

export type FileUploadDataType = {
  name: string;
  author?: string;
  file: File[];
};

export interface IFileUpload {
  name: string;
  author?: string;
  file: File[];
}

export const defaultCompanyForm: ICompanyFormDataType = {
  companyName: "",
  companyTypeId: undefined,
  address: "",
  suite: "",
  city: "",
  state: "",
  zip: "",
  website: "",
  companyId: undefined,
  createdBy: "",
  customerId: undefined,
  userCompanyRoles: [],
};

export const defaultPropertyForm: IPropertyFormDataType = {
  acreage: "",
  address: "",
  yearBuilt: "",
  bbl: "",
  bin: "",
  buildingType: "",
  buildingTypeId: undefined,
  city: "",
  companyId: 0,
  county: "",
  espmPropertyTypeCategoryId: undefined,
  espmPropertyTypeDetailId: undefined,
  file: [],
  floors: "",
  hasWifi: undefined,
  hvacPrimaryTypeIds: [],
  land: undefined,
  latitude: "",
  longitude: "",
  mixedUseComponents: undefined,
  paysBill: "",
  propertyId: undefined,
  propertyName: "",
  propertyTypeId: 0,
  roofSize: "",
  sqft: "",
  state: "",
  suite: "",
  units: "",
  utilityIds: [],
  priorWorkTypeIds: [],
  zip: "",
  electricUtilityProvider: "",
  gasUtilityProvider: "",
};
